import type { VideoInterface } from '../../types/video.interface';
import { StarRating } from '@beholos/holoscommon';

interface Props {
  video: VideoInterface;
  userFirstname: string;
  rating: number;
  selectRating: (rating: number) => void;
  review: string;
  message: string;
  onChangeReview: (event: React.ChangeEvent<HTMLTextAreaElement>) => void;
  onSubmitReview: () => void;
}

export const VideoReviewModal = ({
  video,
  userFirstname,
  rating,
  selectRating,
  review,
  onChangeReview,
  message,
  onSubmitReview
}: Props) => {
  const shareText =
    `¡${userFirstname} te envió un clase en Holos. ¡Estuvo buenísima! Para probar la clase haz click en este link: https://www.beholos.com/clases-online/video/${video.slug}`;

  return (
    <div className="bg-white rounded-xl overflow-hidden max-w-xl mx-auto text-center">
      <div className="bg-gray-100 px-8 py-6">
        <h2 className="text-2xl font-bold mb-4">¡Felicidades! Haz completado esta clase</h2>
        <h4 className="text-lg font-semibold">¿Cómo te fue en esta clase? ¡Tu comentario ayudará a más usuarios!</h4>
        <div className="text-xs text-gray-600 mb-2">
          Has recibido HoloPoints por completar un video on-demand. ¡Deja un review completo y gana 5 extra HoloPoints!
        </div>

        <StarRating
          rating={rating}
          onRatingChange={selectRating}
          size={34}
          className="justify-center mb-4"
        />

        <div className="mb-4">
          <textarea
            maxLength={300}
            value={review}
            onChange={onChangeReview}
            className="w-full p-2 border rounded resize-none"
            rows={4}
            placeholder="Escribe tu opinión..."
          />
          <div className="text-right text-sm mt-1">
            <span className={review.length === 300 ? 'text-red-500' : ''}>
              {300 - review.length} caracteres restantes
            </span>
          </div>
        </div>

        <button
          onClick={onSubmitReview}
          className="bg-holos-dark text-white py-2 px-4 rounded w-full cursor-pointer font-semibold"
        >
          Listo!
        </button>

        <div className="border-b border-gray-400 my-8" />

        <a
          href={`https://api.whatsapp.com/send?text=${encodeURIComponent(shareText)}`}
          target="_blank"
          rel="noopener noreferrer"
          className="flex justify-center border-2 border-green-500 text-black py-2 px-4 rounded w-full block text-sm font-semibold mb-2"
        >
          <img src="https://cache.beholos.com/img/holos/general/brands/whatsapp.svg" alt="WhatsApp Icon" className="w-5 h-5 mr-2" />
          Invita a un amigo a esta clase
        </a>

        <div className="text-xs text-gray-500 mb-2">o comparte este logro</div>

        <div className="flex justify-center space-x-6 text-2xl text-black">
          <a
            href={`https://www.facebook.com/sharer/sharer.php?u=https://www.beholos.com/clases-online/video/${video.slug}&quote=${encodeURIComponent(shareText)}`}
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src="https://cache.beholos.com/img/holos/general/brands/facebook.svg" alt="Facebook Icon" className="w-9 h-9 mb-1" />
          </a>
          <a
            href={`https://x.com/intent/tweet?url=https://www.beholos.com/clases-online/video/${video.slug}&text=${encodeURIComponent(shareText)}`}
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src="https://cache.beholos.com/img/holos/general/brands/x.svg" alt="X Icon" className="w-9 h-9 mb-1" />
          </a>
        </div>
        {message.length > 0 && (
          <p className="text-black font-semibold text-sm mb-4">{message}</p>
        )}
      </div>
    </div>
  );
};